import * as React from "react";
import {Field, reduxForm, InjectedFormProps} from 'redux-form'

import {Action, Dispatch} from "redux";
import {connect} from "react-redux";
import * as Validator from "../../../../../util/validation";

import {AppState} from "../../../../store/app_state";
import {Role} from "../../../../../domain/model/client";
import {clientConfig} from "../../../../../config/language/ja-JP/domain/model_text";
import FormFieldWrapper from "../../../../common/atom/wrapper/form_field_wrapper";
import FormGroupSelectConnectRf from "../../../../common/molecular/form_group/form_group_select_connect_rf";
import {createSelectItem} from "../../../../../util/select_option_function";
import SubmitButtonWrapper from "../../../../common/atom/wrapper/submit_btn_wrapper/submit_btn_wrapper";
import BtnCorporateLarge from "../../../../common/atom/btn/btn_corporate_large";

const validate = (values: any) => {
    const errors: any = {};
    return errors
};

interface IStateProps {
    initialValues?: {
        role: Role;
        clientId: string;
    };
}

interface IProps extends IStateProps {
}

interface IState {
}

export class ClientClientsUpdateRoleForm extends React.Component<IProps & InjectedFormProps<{}, IProps>, IState> {

    constructor(props: IProps & InjectedFormProps<{}, IProps>) {
        super(props);

        this.state = {};

    };

    public render(): JSX.Element {
        const {
            invalid,
            handleSubmit,
            pristine, submitting} = this.props;

        return (
            <React.Fragment>
                <form
                    name="ClientClientsUpdateRoleForm"
                    onSubmit={handleSubmit}>

                    <FormFieldWrapper>
                        <Field
                            name="role"
                            component={FormGroupSelectConnectRf}
                            type="text"
                            validate={[Validator.required]}
                            require={true}
                        >
                        {createSelectItem(false, clientConfig.roleList)}
                        </Field>
                    </FormFieldWrapper>

                    <SubmitButtonWrapper>
                        <BtnCorporateLarge
                            name="ClientCreateForm-submit"
                            type="submit"
                            widthSize="200px"
                            disabled={pristine || submitting || invalid}>変更する</BtnCorporateLarge>
                    </SubmitButtonWrapper>

                </form>
            </React.Fragment>
        )
    };
}

const mapStateToProps = (state: AppState) => {
    return {};
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
    return {};
};


export default reduxForm({
        form: 'ClientClientsUpdateRoleForm',
        validate,
    }
)(connect(mapStateToProps, mapDispatchToProps)(ClientClientsUpdateRoleForm));



// WEBPACK FOOTER //
// ./src/presentation/component/client/clients/info_clients/client_clients_update_role_form.tsx